import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const LogWhatsAppMessageIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "LogWhatsAppMessage",
    children: /*#__PURE__*/_jsx("path", {
      d: "M10.84 8.21c0-.61-.53-1.05-1.05-1.05H7.51V4.8c0-.53-.53-1.05-1.05-1.05s-1.14.53-1.14 1.05v2.27H3.05C2.52 7.07 2 7.6 2 8.21s.53 1.05 1.05 1.05h2.27v2.27c0 .61.44 1.05 1.05 1.05s1.05-.53 1.05-1.05V9.26h2.27c.7 0 1.14-.44 1.14-1.05Zm13.21 11.55s-.88-.44-1.49-.7c-.09 0-.09-.09-.18-.09-.18 0-.26 0-.44.09 0 0-.09.09-.88.96-.09.09-.18.18-.26.18h-.09c-.09 0-.18-.09-.26-.09l-.26-.09a6.5 6.5 0 0 1-1.66-1.05c-.09-.09-.26-.26-.44-.35-.44-.44-.79-.88-1.05-1.4l-.09-.09q-.09-.09-.09-.26c0-.09 0-.17.09-.26l.44-.44c.18-.18.18-.26.26-.44.09-.17.18-.35.09-.53-.26-.7-.53-1.49-.88-2.19a.49.49 0 0 0-.44-.26h-.61c-.09 0-.26.09-.35.09l-.09.09c-.09.09-.26.17-.35.26s-.17.26-.26.35c-.35.53-.61 1.14-.61 1.75 0 .44.09.88.26 1.31l.09.17c.53 1.05 1.22 2.1 2.1 2.89l.26.26c.18.18.35.26.44.44 1.22 1.05 2.62 1.75 4.11 2.19.18.09.44.09.53.09h.53c.26 0 .61-.09.88-.26.18-.09.26-.09.44-.26l.09-.09c.09-.09.26-.18.35-.26.09-.09.18-.18.26-.35.09-.26.18-.53.26-.79v-.44c-.09 0-.09-.09-.18-.09l-.52-.35Zm2.89-9.45c-1.93-2.01-4.55-3.06-7.26-3.06s-5.42 1.14-7.35 3.06-3.06 4.64-3.06 7.44c0 1.84.53 3.59 1.4 5.16l-1.58 5.34 5.51-1.4c1.49.88 3.24 1.22 4.99 1.22 5.78 0 10.41-4.72 10.41-10.5 0-2.71-1.05-5.34-3.06-7.26m-2.8 14.7c-1.31.88-2.89 1.31-4.46 1.31s-3.06-.44-4.38-1.22l-.35-.18-3.33.88.88-3.24-.26-.35c-1.84-2.97-1.75-6.74.35-9.62 2.1-2.89 5.6-4.2 9.01-3.33s5.95 3.59 6.56 7-1.05 6.91-4.02 8.75"
    })
  }));
};